if (!customElements.get('support-toggle')) {
  class SupportToggle extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!this.hasAttribute('open')) {
        this.removeAttribute('open');
        document
          .querySelector(`support-modal.is-open`)
          ?.classList.remove('is-open');
        bodyScroll.clear();
      } else {
        this.setAttribute('open', true);
      }

      document.dispatchEvent(
        new CustomEvent(`${this.id}:toggle`, {
          detail: {
            id: this.getAttribute('data-product-id'),
            title: this.getAttribute('data-product-title'),
            variantId: this.getAttribute('data-variant-id'),
          },
        }),
      );
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this), false);
    }
  }

  customElements.define('support-toggle', SupportToggle);
}
